window.addEventListener('load', function () {
  function updateWishlistIcons() {
    const hosts = Array.from(document.querySelectorAll('*')).filter(el => el.shadowRoot);

    hosts.forEach(host => {
      const icons = host.shadowRoot.querySelectorAll('.gw-wl-icon'); 
      icons.forEach(icon => {
        const button = icon.closest('button');
        if (!button) return;

        const inWishlist = button.getAttribute('data-in-wishlist') === 'true';

        if (inWishlist) {
          // Filled #56a475
          icon.style.color = '#56a475';
          icon.querySelectorAll('*').forEach(el => {
            el.setAttribute('stroke', '#56a475');
            el.setAttribute('fill', '#56a475');
          });
        } else {
          // Outline #56a475
          icon.style.color = '#56a475';
          // icon.style.boxShadow = '0px 0px 5px 3px rgba(86, 164, 117, 1)';
          // icon.style.borderRadius = '10px';
          icon.querySelectorAll('*').forEach(el => {
            el.setAttribute('stroke', '#56a475');
            el.setAttribute('fill', 'none');
          });
        }
      });

      const icons_counter = host.shadowRoot.querySelectorAll('.gw-toggle-wishlist-product-card-button__counter--right-top');
      icons_counter.forEach(icon_counter => {
        icon_counter.style.display = 'none';
      });

      const deleteBtnCounters = host.shadowRoot.querySelectorAll('.gw-wl-page-item__delete-btn-counter');
      deleteBtnCounters.forEach(deleteBtnCounter => {
        deleteBtnCounter.style.display = 'none';
      });
    });
  }

  // Check periodically for new icons or state changes
  setInterval(updateWishlistIcons, 100);
});